import { choseCameraPlayBack } from "../utils"
import { GET_AVATAR_HEADER, GET_CAMERA_CODE, GET_LIST_CAMERA, GET_LIST_CAMERA_PRIORITY, GET_LIST_CODE_CAMERA, GET_LIST_WAREHOUSE, GET_PATH_NOTIFICATION, GET_USER_NAME, GET_USER_TYPE, GET_VIEW_PORT, REDIRECT_FOCUS, RE_GET_NOTIFICATION, SEARCH_CAM_PLAYBACK, SET_DATA_REGISTER, SET_EMAIL_FORGOT_PASS, SET_FILTER_CAMERA, SET_LIST_SERVICE, SET_SELECTED_AI_ALERT, SET_TOKEN_USER, SET_USER_PENDING_ACCEPT } from "./Constants"

const initState = {
    dataUserRegister: {
        name: '',
        username: '',
        email: '',
        password: '',
        confirmpassword: '',
        company_code: '',
        permissions_code: ''
    },
    emailForgotPassword: '',
    tokenUser: '',
    wareHouses: {
        indexWareHouse: null,
        indexLocation: null,
    },
    toggleNotification: false,
    userName: '',
    userType: null,
    listCameraPriority: [{
        camera_code: '',
    }],
    toggleFocus: false,
    listWareHouse: [],
    viewPort: null,
    cameraCode: null,
    listCodeCamera: [],
    pathNotification: {
        path: null,
        nameCamera: null,
        nameNotification: null,
        time: null,
        cameraCode: null,
    },
    selectedAiAlert: null,
    userPendingAc: { userName: '', typeCode: '' },
    filterCamera: {
        cameraName: '',
        company: 'all',
        address: 'all',
        status: 'all',
        currentPage: 1,
        triger: 'clear'
    },
    listService: [],
    reGetAvatarHeader: false
}


function reducer(state, action) {
    switch (action.type) {
        case SET_DATA_REGISTER:
            return {
                ...state,
                dataUserRegister: {
                    name: action.payload.name,
                    username: action.payload.userName,
                    email: action.payload.email,
                    password: action.payload.password,
                    confirmpassword: action.payload.confirmPassword,
                    company_code: action.payload.companyName,
                    permissions_code: action.payload.permission,
                }
            }
        case SET_EMAIL_FORGOT_PASS:
            return {
                ...state,
                emailForgotPassword: action.payload
            }
        case SET_TOKEN_USER:
            return {
                ...state,
                tokenUser: action.payload
            }
        case GET_LIST_CAMERA:
            return {
                ...state,
                wareHouses: {
                    indexWareHouse: action.payload.indexWareHouse,
                    indexLocation: action.payload.indexLocation,
                }
            }
        case RE_GET_NOTIFICATION:
            return {
                ...state,
                toggleNotification: !state.toggleNotification
            }
        case GET_USER_NAME:
            return {
                ...state,
                userName: action.payload
            }
        case GET_LIST_CAMERA_PRIORITY:
            const listCodePriority = [...state.listCameraPriority];
            const payloadPriorityData = [action.payload];
            const payloadCodePriorityDifferent = payloadPriorityData.filter((payload) => listCodePriority.findIndex(item => item.camera_code === payload.camera_code) < 0);
            const statePriorityDifferent = listCodePriority.filter((itemCode) => payloadPriorityData.findIndex(item => item.camera_code === itemCode.camera_code) < 0);
            const mergerTwoArray = payloadCodePriorityDifferent.concat(statePriorityDifferent);
            const index = mergerTwoArray.findIndex(item => item.camera_code === '')
            if (index > 0) {
                mergerTwoArray.splice(index, 1)
            }
            mergerTwoArray.push(action.payload)
            if (action.payload) {
                return {
                    ...state,
                    listCameraPriority: [...mergerTwoArray]
                }
            } else {
                return {
                    ...state,
                    listCameraPriority: []
                }
            }
        case REDIRECT_FOCUS:
            return {
                ...state,
                toggleFocus: action.payload,
            }
        case GET_LIST_WAREHOUSE:
            return {
                ...state,
                listWareHouse: action.payload
            }
        case GET_VIEW_PORT:
            return {
                ...state,
                viewPort: action.payload
            }
        case GET_USER_TYPE:
            return {
                ...state,
                userType: action.payload
            }
        case GET_CAMERA_CODE:
            return {
                ...state,
                cameraCode: action.payload
            }
        case GET_LIST_CODE_CAMERA:
            const listCode = [...state.listCodeCamera]
            let payloadData = action.payload;
            let listNewItem = choseCameraPlayBack(listCode, payloadData);
            return {
                ...state,
                listCodeCamera: [...listNewItem]
            }
        case SEARCH_CAM_PLAYBACK:
            let payloadSearch = action.payload;
            return {
                ...state,
                listCodeCamera: [...payloadSearch]
            }
        case GET_PATH_NOTIFICATION:
            return {
                ...state,
                pathNotification: {
                    path: action.payload.path,
                    nameCamera: action.payload.nameCamera,
                    nameNotification: action.payload.nameNotification,
                    time: action.payload.time,
                    cameraCode: action.payload.codeCamera,
                }
            }
        case SET_USER_PENDING_ACCEPT:
            return {
                ...state,
                userPendingAc: action.payload
            }
        case SET_FILTER_CAMERA:
            return {
                ...state,
                filterCamera: action.payload,
            }
        case SET_LIST_SERVICE:
            return {
                ...state,
                listService: action.payload,
            }
        case GET_AVATAR_HEADER:
            return {
                ...state,
                reGetAvatarHeader: action.payload,
            }
        case SET_SELECTED_AI_ALERT:
            return {
                ...state,
                selectedAiAlert: action.payload,
            }
        default:
            throw new Error('Invalid action')
    }
}

export { initState }
export default reducer